import { useState, useEffect } from "react";
import { List, Card, Space, Typography } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import "./DokumentCardsKorisnik.css";
import { formatDateTime } from "../../utils/formatDateTime";

const { Text } = Typography;

const handleOpenPdf = async (dokument) => {
  if (!dokument.putanja) return;

  const filename = dokument.putanja.split("/").pop();
  const url = `/dokument/preview/${filename}`;

  const isPdf = filename.toLowerCase().endsWith(".pdf");

  if (isPdf) {
    window.open(url, "_blank");
  } else {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }, 100);
    } catch (error) {
    }
  }
};

function DokumentCardsKorisnik({ dokumenti }) {
  const [columns, setColumns] = useState(4);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentDokumenti = dokumenti.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(dokumenti.length / itemsPerPage);

  useEffect(() => {
    const handleResize = () => {
      setColumns(window.innerWidth < 480 ? 1 : 4);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <List
      grid={{ gutter: 16, xs: 1, sm: 1, md: 3, lg: 4, xl: 4, xxl: 4 }}
      dataSource={currentDokumenti}
      style={{ marginTop: "10px", marginBottom: "0px" }}
      locale={{ emptyText: "Nema dostupnih dokumenata." }}
      renderItem={(dokument, index) => {
        const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
        const backgroundColor = colors[index % colors.length];

        return (
          <List.Item>
            <div className="document-cards">
              <Card
                hoverable
                onClick={() => handleOpenPdf(dokument)}
                cover={
                  <div
                    className="dokument-card-cover"
                    style={{ backgroundColor }}
                  >
                    <FileTextOutlined
                      style={{ fontSize: 48, color: "#2b494b" }}
                    />
                  </div>
                }
              >
                <div className="dokument-card-title">{dokument.naziv}</div>

                <Space className="dokument-card-footer" align="center" size={4}>
                  <Text type="secondary">
                    <span>({dokument.putanja.split(".").pop()}) </span>
                    {formatDateTime(dokument.datumDodavanja)}
                  </Text>
                </Space>
              </Card>
            </div>
          </List.Item>
        );
      }}
    >
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            {" "}
            Prethodna{" "}
          </button>
          <span>
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            {" "}
            Sljedeća
          </button>
        </div>
      )}
    </List>
  );
}
export default DokumentCardsKorisnik;
